/** Lamports in one SOL — Solana's smallest unit, 1 SOL = 1e9 lamports. */
export const LAMPORTS_PER_SOL = 1_000_000_000;
/** Address of the SPL Token program — owns all classic SPL token accounts. */
export const SPL_TOKEN_PROGRAM_ID = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA';
/** Address of the SPL Token-2022 program — owns Token-2022 (extensions) accounts. */
export const SPL_TOKEN_2022_PROGRAM_ID = 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb';
